import axios from 'axios';

export const trackingVitally = async (eventName) => {
  try {
    await axios.post('/api/track', { eventName });
  } catch (error) {
    console.error('trackingVitally error: ', error);
  }
};